import { render, staticRenderFns } from "./InGameSumoRing.vue?vue&type=template&id=62d6463a&scoped=true&"
import script from "./InGameSumoRing.vue?vue&type=script&lang=js&"
export * from "./InGameSumoRing.vue?vue&type=script&lang=js&"
import style0 from "./InGameSumoRing.vue?vue&type=style&index=0&id=62d6463a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d6463a",
  null
  
)

component.options.__file = "InGameSumoRing.vue"
export default component.exports